import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
  container:{
    display:"flex",
    flexDirection:"column",
    width: "690px",
    flexShrink: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  text: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  header: {
    color:theme.palette.primary.main,
    marginBottom: "0 !important",
    marginTop: "0 !important",
    paddingBottom:"0 !important"
  }
}));